import loadable from '@loadable/component';

export const CmsPersonaQuizBlockLoadable = loadable(
  () => import('./CmsPersonaQuizBlock'),
  { resolveComponent: (module) => module.CmsPersonaQuizBlock },
);
